export const getMeasureInWindow = (dom: HTMLElement) => {
  const rect = dom.getBoundingClientRect();

  return {
    y: rect.top + window.scrollY,
    x: rect.left + window.scrollX,
    width: rect.width,
    height: rect.height,
  };
};
